import { render, staticRenderFns } from "./stars_home.vue?vue&type=template&id=0c9caa52&"
import script from "./stars_home.vue?vue&type=script&lang=js&"
export * from "./stars_home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports